import { ULM_PROFILE_EVENT } from "./events";
export default function dispatchUlmProfileEvent(detail) {
    window.dispatchEvent(new CustomEvent(ULM_PROFILE_EVENT, { detail: detail }));
}
